<script setup lang="ts">
import { TabsTrigger, type TabsTriggerProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends ClassProps, TabsTriggerProps {}

const props = defineProps<Props>();
const delegatedProps = useDelegatedProps(props);
</script>

<template>
	<TabsTrigger :class="cn('tab', props.class)" v-bind="delegatedProps">
		<slot />
	</TabsTrigger>
</template>
